export default __webpack_public_path__ + "static/media/loading-bars.29a96f04.gif";